import { Component, OnInit } from '@angular/core';
import { DroneService } from 'src/app/services/drone/drone.service';

@Component({
  selector: 'app-list-drone',
  templateUrl: './list-drone.component.html',
  styleUrls: ['./list-drone.component.sass']
})
export class ListDroneComponent implements OnInit {
  drones: Array<any>

  constructor(
    private droneService: DroneService
  ) { }

  ngOnInit(): void {
    this.drones = []
    this.getDrones()
  }

  getDrones() {
    this.droneService.findAll().subscribe(res => {
      this.drones = res;
    })
  }
}
